// Enterprise-SSO slug persistence (Epic CORE-6317). Mirrors l2u-team-portal's sso-slug.util.
//
// The Identity Server routes a user to their branded /{slug}/login → Entra/Okta page only
// when the authorize request carries acr_values=sso:<slug>, so the SPA remembers the slug
// the user entered through and replays it on re-auth.
//
// Lifetime (CORE-7425): written only by loginWithSso() when the user enters through
// /{slug}/login; replaced when they enter through a different one; kept across token
// expiry (the router guard's re-auth) so that lands on the branded page; cleared by an
// explicit logout, by a confirmed cross-portal sign-out, and by the generic /login route,
// so the next sign-in is the generic login and the browser is not pinned to one customer.
export const SSO_SLUG_KEY = 'l2u:ssoSlug';

// Lowercase kebab-case, matching the Identity Server SsoSlugConstraint (incl. its
// reserved words) so we never build an acr_values the IS would refuse to resolve.
const SSO_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const RESERVED_SSO_SLUGS = ['account', 'external', 'sso', 'home', 'connect', 'health', 'error', 'register', 'trial'];

export function normalizeSsoSlug(slug) {
    if (!slug) return null;
    const normalized = String(slug)
        .trim()
        .toLowerCase();
    if (!SSO_SLUG_PATTERN.test(normalized) || RESERVED_SSO_SLUGS.indexOf(normalized) !== -1) {
        return null;
    }
    return normalized;
}

export function getSsoSlug() {
    try {
        return normalizeSsoSlug(window.localStorage.getItem(SSO_SLUG_KEY));
    } catch (e) {
        return null;
    }
}

export function setSsoSlug(slug) {
    const normalized = normalizeSsoSlug(slug);
    if (!normalized) return;
    try {
        window.localStorage.setItem(SSO_SLUG_KEY, normalized);
    } catch (e) {
        // ignore storage errors
    }
}

// Forgets the slug so the next sign-in is generic. Explicit sign-out only — see the lifetime above.
export function clearSsoSlug() {
    try {
        window.localStorage.removeItem(SSO_SLUG_KEY);
    } catch (e) {
        // ignore storage errors
    }
}

// signinRedirect args carrying the persisted slug's acr_values, or {} for non-SSO.
export function ssoAcrArgs() {
    const slug = getSsoSlug();
    return slug ? { acr_values: `sso:${slug}` } : {};
}
